import React from 'react';
import DepartmentForm from './DepartmentForm';
import { addDepartment } from '../../api';

export default class extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.appBar = {
      title: 'NEW_DEPARTMENT',
      navigateBack: true,
    };
  }

  render() {
    return (
      <DepartmentForm
        name="addDepartment"
        appBar={this.appBar}
        request={addDepartment}
        confirmExit
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Department/DepartmentAddition.js
 **/